'use client';

import { useOnceEffect } from '@/hooks/useOnceEffect';
import type { TossPixelEventParams } from '@/types/global';
import type { TossPixelMethod } from '@/utils/analytics/toss-pixel';
import { trackTossPixelEvent } from '@/utils/analytics/toss-pixel';

export const TossPixelEventTrigger = ({
  method,
  params,
}: {
  method: TossPixelMethod;
  params?: TossPixelEventParams;
}) => {
  useOnceEffect(() => {
    trackTossPixelEvent(method, params);
  });

  return null;
};
